import { createSelector } from "@reduxjs/toolkit";

/**
 * @typedef  {import("./trade").RootState}  RootState
 * @typedef { import("../../..").IPeerSetting } IPeerSetting 
 * @typedef { import("../../..").IInstrumentSetting } IInstrumentSetting 
 * @param { RootState } state
 * @returns { import("../../..").CompanySetting }
 */
export const companySettingsSelector = (/** @type {RootState} */state) => state.companySettings.settings;

export const companyExternalSettingsSelector = (/**@type { RootState } */state) => state.companySettings.external;

/**
 * @param {} state
 * @returns { import("../../..").IInstrumentSetting[] }
 */
export const instrumentsSettingsSelector = (state) => companySettingsSelector(state).instruments;

export const peersSettingsSelector = (state) => companySettingsSelector(state).peers;

/**
 * @param {} state
 * @returns { import("../../..").TTemplate }
 */
export const templateSettingsSelector = (state) => companySettingsSelector(state).template;

/**
 * @param {} state
 * @returns { import("../../..").IFormatSetting }
 */
export const formatSettingsSelector = (state) => companySettingsSelector(state).format;

/**
 * @param {} state
 * @returns { import("../../..").DefaultTab }
 */
export const defaultTabSettingsSelector = (state) => companySettingsSelector(state).defaultTab;

/**
 * @param {} state
 * @returns { import("../../..").currencyEnabled }
 */
export const currencyEnabledSettingsSelector = (state) => companySettingsSelector(state).currencyEnabled;

/**
 * @param {} state
 */
export const currenciesSelector = (state) => companySettingsSelector(state).currencies;

export const colorBlindModeSelector = (state) => companyExternalSettingsSelector(state).colorBlindMode;

export const enableColorBlindModeSelector = (state) => companyExternalSettingsSelector(state).enableColorBlindMode;

export const currenciesNameSelector = (state) => companyExternalSettingsSelector(state).currenciesName

export const instrumentSettingsIndexer = createSelector([
  (state) => companySettingsSelector(state).instruments, 
  (state) => companySettingsSelector(state).peers,
  formatSettingsSelector
], (instruments, peers, format) => {
  return [...instruments, ...peers].reduce((acc, item) => {
    acc[item.id] = {
      ...item,
      decimalDigits: item.decimalDigits ?? format.decimalDigits,
      decimalSeparator: item.decimalSeparator || format.decimalSeparator,
      thousandsSeparator: item.thousandsSeparator || format.thousandsSeparator,
    };
    return acc;
  }, /** @type { Record<number, IPeerSetting | IInstrumentSetting>} */ ({}))
})

export const formatSettingIndexerSelector = createSelector(formatSettingsSelector, format => format)

export const currenciesSettingIndexerSelector = createSelector(currenciesSelector, (currency) => {
  return currency.reduce((acc, item) => {
    acc[item.code] = item.text;
    return acc;
  }, /** @type { Record<string, string>} */ ({}))
})

